import React, { useEffect, useState } from 'react';
//Material-UI
import { Button, IconButton, Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
//Icons
import { CirclePlus, CircleMinus } from 'tabler-icons-react';
//Styles
import '../styles/capacidades.css';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function CapField({ label, helper, value, onChange }) {
    return (
        <div className="cap-default-field">
            <div className="cap-default-label">{label}</div>
            <div className="cap-default-counter">
                <IconButton size="small" onClick={() => onChange(Math.max(0, parseInt(value || 0) - 1))}>
                    <CircleMinus size={16} strokeWidth={1.75} color="#7d7f90" />
                </IconButton>
                <input
                    type="number"
                    className="cap-default-input"
                    value={value}
                    min={0}
                    onChange={(e) => onChange(Math.max(0, parseInt(e.target.value) || 0))}
                />
                <IconButton size="small" onClick={() => onChange(parseInt(value || 0) + 1)}>
                    <CirclePlus size={16} strokeWidth={1.75} color="#7d7f90" />
                </IconButton>
            </div>
            {helper && <div className="cap-default-helper">{helper}</div>}
        </div>
    );
}

const SimpleList = () => {
    const tokenSessionObject = JSON.parse(sessionStorage.getItem('token'));
    const [lines, setLines] = useState([]);
    const [linea, setLinea] = useState(null);
    const [piezasPorPaquete, setPiezasPaquete] = useState(0);
    const [ritmoEstandar, setRitmoEstandar] = useState(0);
    const [ritmoIdeal, setRitmoIdeal] = useState(0);
    const [valorRollover, setValorRollover] = useState(0);
    const [nombreLinea, setNombreLinea] = useState('');
    const [verNombreLinea, setVerNombreLinea] = useState('');
    const [jsonStatus, setJsonStatus] = useState(400);
    const [snackbar, setSnackbar] = useState(false);

    useEffect(() => {
        const getLines = async () => {
            try {
                if (!tokenSessionObject?.token) return;
                const res = await fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT}/lineas`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${tokenSessionObject.token}`,
                        Accept: 'application/json',
                    },
                });
                if (!res.ok) return;
                setLines(await res.json());
            } catch (error) {
                console.error('Error al obtener líneas:', error);
            }
        };
        getLines();
    }, [tokenSessionObject.token]);

    const getCapacity = async (newLinea) => {
        await fetch(
            `${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidadesdefault/GetCapacidadesDefault?linea=${newLinea}`,
            {
                method: 'GET',
                headers: {
                    authorization: `Bearer ${tokenSessionObject.token}`,
                    Accept: 'application/json',
                },
            }
        ).then(async (response) => {
            const isJson = response.headers.get('content-type')?.includes('application/json');
            const data1 = isJson && (await response.json());
            if (!response.ok) {
                setLinea(newLinea);
                setNombreLinea(lines[newLinea - 1].nombre);
                setVerNombreLinea(lines[newLinea - 1].nombre);
                setPiezasPaquete(0);
                setRitmoEstandar(0);
                setRitmoIdeal(0);
                setValorRollover(0);
                setJsonStatus(400);
            } else {
                setLinea(newLinea);
                setPiezasPaquete(data1.piezasPorPaquete);
                setRitmoEstandar(lineaLenta && data1.ritmoEstandar > 0 ? Math.round(1 / data1.ritmoEstandar) : data1.ritmoEstandar);
                setRitmoIdeal(lineaLenta && data1.ritmoIdeal > 0 ? Math.round(1 / data1.ritmoIdeal) : data1.ritmoIdeal);
                setValorRollover(data1.valorRollover);
                setNombreLinea(data1.nombreLinea);
                setVerNombreLinea(data1.nombreLinea);
                setJsonStatus(200);
            }
        });
    };

    const functionGuardar = async () => {
        const data = {
            linea: linea,
            piezasPorPaquete,
            ritmoIdeal: lineaLenta && ritmoIdeal > 0 ? 1 / ritmoIdeal : ritmoIdeal,
            ritmoEstandar: lineaLenta && ritmoEstandar > 0 ? 1 / ritmoEstandar : ritmoEstandar,
            valorRollover: parseInt(valorRollover),
            nombreLinea,
        };
        const url = jsonStatus === 200
            ? `${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidadesdefault/Actualizar`
            : `${process.env.REACT_APP_SERVICE_ENDPOINT}/capacidadesdefault/Insertar`;
        const method = jsonStatus === 200 ? 'PUT' : 'POST';

        await fetch(url, {
            method,
            body: JSON.stringify(data),
            headers: {
                authorization: `Bearer ${tokenSessionObject.token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        }).then((response) => {
            if (response.ok) {
                setSnackbar(true);
                setJsonStatus(200);
            }
        });
    };

    const allowPiezas = process.env.REACT_APP_ALLOW_CAP_PIEZAS !== 'false';
    const allowIdeal = process.env.REACT_APP_ALLOW_CAP_VELOCIDAD_IDEAL !== 'false';
    const allowEstandar = process.env.REACT_APP_ALLOW_CAP_VELOCIDAD_ESTANDAR !== 'false';
    const allowRollover = process.env.REACT_APP_ALLOW_CAP_ROLLOVER !== 'false';
    const lineaLenta = process.env.REACT_APP_LINEA_LENTA === 'true';

    return (
        <div className="cap-layout">
            {/* ── Lines panel ── */}
            <div className="cap-panel-lines">
                <div className="cap-card">
                    <div className="cap-card-toolbar">
                        <h3 className="cap-card-title">Líneas</h3>
                    </div>
                    <div className="cap-lines-list">
                        {lines.map((item) => (
                            <div
                                key={item.id}
                                className={`cap-line-item${linea === item.id ? ' cap-line-item--selected' : ''}`}
                                onClick={() => getCapacity(item.id)}
                            >
                                {item.nombre}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ── Fields panel ── */}
            <div className="cap-panel-fields">
                <div className="cap-card">
                    <div className="cap-card-toolbar">
                        <h3 className="cap-card-title">
                            {linea ? verNombreLinea : 'Selecciona una línea'}
                        </h3>
                    </div>
                    {!linea ? (
                        <div className="cap-empty">
                            Selecciona una línea para editar sus capacidades
                        </div>
                    ) : (
                        <div key={linea} className="cap-fields-animate">
                            <div className="cap-fields-grid">
                                {allowPiezas && (
                                    <CapField
                                        label="Piezas por paquete"
                                        value={piezasPorPaquete}
                                        onChange={setPiezasPaquete}
                                    />
                                )}
                                {allowIdeal && (
                                    <CapField
                                        label={lineaLenta ? 'Tiempo ideal' : 'Velocidad ideal'}
                                        helper={lineaLenta ? 'Minutos por pieza' : 'Piezas / Minuto'}
                                        value={ritmoIdeal}
                                        onChange={setRitmoIdeal}
                                    />
                                )}
                                {allowEstandar && (
                                    <CapField
                                        label={lineaLenta ? 'Tiempo estándar' : 'Velocidad estándar'}
                                        helper={lineaLenta ? 'Minutos por pieza' : 'Piezas / Minuto'}
                                        value={ritmoEstandar}
                                        onChange={setRitmoEstandar}
                                    />
                                )}
                                {allowRollover && (
                                    <CapField
                                        label="Valor rollover"
                                        value={valorRollover}
                                        onChange={setValorRollover}
                                    />
                                )}
                            </div>
                            <div className="cap-card-footer">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className="cap-btn"
                                    onClick={functionGuardar}
                                >
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Snackbar
                open={snackbar}
                autoHideDuration={3000}
                onClose={() => setSnackbar(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert onClose={() => setSnackbar(false)} severity="success">
                    Capacidades guardadas correctamente
                </Alert>
            </Snackbar>
        </div>
    );
};

export default SimpleList;
